import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import "./software-testing.css";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0 },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07 } },
};

const functionalBenefits = [
  {
    title: "More Accuracy",
    text: "Performing functional testing ensures the accuracy factor. Tested software tends to be error free thus providing better outputs and leads to customer satisfaction. There are various benefits of functional testing.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3l7 4v5c0 4.4-3 8.5-7 9-4-0.5-7-4.6-7-9V7l7-4Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9.5 12.5 11 14l3.5-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    accent: false,
  },
  {
    title: "Saves Time",
    text: "Manually performing the tests for product requires lot of time and money but automated functional testing can be performed again and again with reduced cost and time.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 5l12 7-12 7V5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M19 5v14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    accent: true,
  },
  {
    title: "Builds Business Status",
    text: "Functional testing provides defect free product building trust among customers and hence improving brand's reputation. Opting for functional testing saves both the time and money.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 10v8h16v-8M4 10l8-6 8 6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9 18v-4h6v4" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
    accent: false,
  },
];

const functionalServices = [
  {
    title: "Website Testing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
        <path d="M3 12h18M12 3c2.5 2.8 4 6 4 9s-1.5 6.2-4 9M12 3c-2.5 2.8-4 6-4 9s1.5 6.2 4 9" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "Compatibility Testing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Security Testing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 11V8a4 4 0 1 1 8 0v3" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    title: "White Box Testing",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 7h16v10H4V7Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 11h8M8 14h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const testingTypes = [
  {
    title: "System Integration Testing",
    text: "Performance testing of the product functionality in an integrated scenario via severe module.",
  },
  {
    title: "Functionality Testing",
    text: "Validation of the whole component or function of the product.",
  },
  {
    title: "End-To-End Testing",
    text: "Testing requirements as well as test execution, along with detailed management and reporting.",
  },
  {
    title: "Usability Testing",
    text: "See how easy to use something is by testing it with real users.",
  },
];

const performanceBenefits = [
  "Performance testing enhances optimization and capacity planning efforts.",
  "It provides information about the areas which need improvement in software.",
  "It inspects the quality of product and if there is any defect it identifies and rectifies that.",
  "It helps in measuring the end user response time and user load level.",
  "Identifies the performance boundaries and discover bug in each component.",
  "It ensures the accuracy and reliability of the product in market building great reputation.",
];

const performanceTools = [
  "Apache JMeter",
  "LoadRunner",
  "LoadUI",
  "OpenSTA",
  "WebLOAD",
  "Appvance",
  "Loadster",
  "Loadstorm",
  "Grinder",
  "WAPT",
  "LoadImpact",
  "LoadComplete",
  "Tsung",
  "NeoLoad",
  "Rational Performance",
  "Loader",
];

const regressionBenefits = [
  "It detects the bugs which might have occurred with installation or modification of new codes.",
  "It ensures data integrity and validation after the errors have been fixed.",
  "It helps you in understanding the requirements of application. WebTech Software Solutions is the best regression testing service in Bangalore providing solutions to fix issues in software for better performance.",
  "It saves the time and energy since regression testing is often performed by automation tools.",
  "There are many applications which require continuous modifications — regression testing is of great importance for such applications.",
  "It also ensures that the bugs detected earlier are no longer creatable again. This testing technique provides quality oriented product with required application modifications.",
];

const mobileBenefits = [
  "It saves the time and energy.",
  "It builds customer's loyalty and trust.",
  "It increases the reliability and accuracy of the application.",
  "It increases the credibility and efficiency of the application.",
  "It identifies all the bugs and areas which require modification and improvement.",
  "It is cost effective as it detects the error in the starting of the program saving the costs required for re-designing the application if error is found later.",
  "It helps in building the reputation of the company. As the product is more efficient and error-free it creates the brand image and enhances its reputation in the competitive business market.",
];

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AnimatedSection: React.FC<{
  className?: string;
  children: React.ReactNode;
}> = ({ className = "", children }) => (
  <motion.section
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-80px" }}
    variants={fadeUp}
    transition={{ duration: 0.6, ease: "easeOut" }}
  >
    {children}
  </motion.section>
);

const SectionHeader: React.FC<{
  eyebrow?: string;
  title: string;
  text?: string;
  light?: boolean;
  center?: boolean;
}> = ({ eyebrow, title, text, light = false, center = true }) => (
  <div className={`stest-section-head ${light ? "stest-section-head--light" : ""} ${center ? "stest-section-head--center" : ""}`}>
    {eyebrow && <span className="stest-label">{eyebrow}</span>}
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
);

const SoftwareTestingPage: React.FC = () => {
  useEffect(() => {
    document.title = "Software Testing Services | WebTech Software Solutions Bangalore";
    const description =
      "Top functional, performance, regression, and mobile testing company in Bangalore. WebTech delivers quality assurance for web and mobile applications.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="stest-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            {/* Hero */}
            <section className="stest-hero" aria-labelledby="stest-hero-title">
              <div className="stest-hero__bg" aria-hidden="true" />
              <div className="stest-container stest-hero__inner">
                <motion.div
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.65 }}
                >
                  <nav className="stest-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Home</Link>
                    <span>/</span>
                    <Link to="/service">Services</Link>
                  </nav>
                  <span className="stest-label">Quality Assurance</span>
                  <h1 id="stest-hero-title">
                    Software <span>Testing</span> Services
                  </h1>
                  <p>
                    Verification and validation for every function — ensuring quality,
                    stability, and confidence before your product reaches users.
                  </p>
                  <Link className="stest-btn stest-btn--primary" to="/contact">
                    Get Free Consultation
                  </Link>
                </motion.div>
              </div>
            </section>

            {/* Functional Testing Intro */}
            <AnimatedSection className="stest-section stest-section--white">
              <div className="stest-container stest-intro">
                <div className="stest-intro__content">
                  <SectionHeader
                    eyebrow="Functional Testing"
                    title="Top Functional Testing Company in Bangalore"
                    center={false}
                  />
                  <p>
                    Functional testing is basically the verification and validation of each
                    function of software application. With our best testing expertise we are
                    one of the top software functional testing companies in Bangalore.
                    Functional testing ensures the quality and stability of the product to
                    users.
                  </p>
                  <p>
                    Testing basically tells about &ldquo;can this task be performed&rdquo; or
                    &ldquo;does this feature respond properly&rdquo;. It is a good instrument
                    which gives quality assurance and checks software ability to do various
                    tasks. Clients also focus on the importance of functional testing as it
                    minimizes the risk factor.
                  </p>
                  <p>
                    Functions are generally tested by providing input and examining the output.
                    It does not focus on how the process is happening but on the result of
                    processing. For a company, the most important thing to build its reputation
                    is to maintain and improve the quality and efficiency of their product.
                    Functional testing checks the functionality and efficiency of the product
                    before delivering it to users.
                  </p>
                </div>
                <div className="stest-intro__visual" aria-hidden="true">
                  <div className="stest-qa-panel">
                    <div className="stest-qa-panel__row">
                      <span className="stest-qa-panel__dot stest-qa-panel__dot--pass" />
                      <span>Input validation</span>
                      <strong>PASS</strong>
                    </div>
                    <div className="stest-qa-panel__row">
                      <span className="stest-qa-panel__dot stest-qa-panel__dot--pass" />
                      <span>Feature response</span>
                      <strong>PASS</strong>
                    </div>
                    <div className="stest-qa-panel__row">
                      <span className="stest-qa-panel__dot stest-qa-panel__dot--pass" />
                      <span>Output accuracy</span>
                      <strong>PASS</strong>
                    </div>
                    <div className="stest-qa-panel__row">
                      <span className="stest-qa-panel__dot stest-qa-panel__dot--warn" />
                      <span>Edge case handling</span>
                      <strong>TEST</strong>
                    </div>
                    <div className="stest-qa-panel__bar">
                      <span style={{ width: "92%" }} />
                    </div>
                    <p>Quality score: 92%</p>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            {/* Functional Benefits */}
            <AnimatedSection className="stest-section">
              <div className="stest-container">
                <motion.div className="stest-benefit-grid" variants={stagger}>
                  {functionalBenefits.map((item) => (
                    <motion.article
                      key={item.title}
                      className={`stest-benefit-card ${item.accent ? "stest-benefit-card--light" : ""}`}
                      variants={fadeUp}
                    >
                      <div className="stest-benefit-card__icon">{item.icon}</div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </motion.article>
                  ))}
                </motion.div>
              </div>
            </AnimatedSection>

            {/* Wide Range + Functional Services */}
            <AnimatedSection className="stest-section stest-section--white">
              <div className="stest-container">
                <SectionHeader
                  title="Wide Range of Testing Services for the Finest Outcome"
                  text="Functional testing fulfills the need to determine the compliance of any application with the stated requirements. It can be considered as Graphical User Interface test conducted on an integrated system. It consists of thorough testing and validation of all competence, features, and functions of a software. WebTech Software Solutions is the top functional testing company in Bangalore."
                />
                <SectionHeader
                  title="Functional Testing Services"
                  text="The world of applications is changing and evolving with the passage of time. Platforms and operating systems continue to enhance the experience of users through improvements and frequent updates — and your software must keep pace."
                />
                <div className="stest-icon-grid">
                  {functionalServices.map((item) => (
                    <article className="stest-icon-card" key={item.title}>
                      <div className="stest-icon-card__icon">{item.icon}</div>
                      <h3>{item.title}</h3>
                    </article>
                  ))}
                </div>
                <div className="stest-type-grid">
                  {testingTypes.map((item) => (
                    <article className="stest-type-card" key={item.title}>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </article>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Performance Testing */}
            <AnimatedSection className="stest-section stest-section--dark stest-section--overlay">
              <div className="stest-container">
                <SectionHeader
                  eyebrow="Performance Testing"
                  title="Why Do Performance Testing?"
                  text="Performance testing is crucial for growth and success of business. A poor performing system or software not only leads to financial losses but also de-accelerates your business growth. If a software or system is launched without performance testing it might have some undetected quality issues which is likely to create bad reputation and loss in the market. WebTech is the best software performance testing company in Bangalore."
                />
                <p className="stest-lead">
                  Performance testing is performed to evaluate the speed and effectiveness of a
                  software program, network, computer or device. It determines how a system
                  performs in terms of responsiveness and stability under certain situations. It
                  investigates and measures quality attributes like speed, scalability,
                  reliability, stability and resource usage. It helps verify whether the system
                  meets the specifications claimed by the manufacturer. Effective performance
                  testing can quickly uncover problem areas which need improvement and eliminates
                  performance bottlenecks before your product goes to market.
                </p>
                <div className="stest-check-grid">
                  {performanceBenefits.map((item) => (
                    <div className="stest-check-item" key={item}>
                      <CheckIcon />
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Performance Tools */}
            <AnimatedSection className="stest-section stest-section--tools">
              <div className="stest-container">
                <SectionHeader title="Best Performance Testing Tools" />
                <div className="stest-tools-grid">
                  {performanceTools.map((tool) => (
                    <div className="stest-tool-item" key={tool}>
                      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                      <span>{tool}</span>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>

            {/* Regression Testing */}
            <AnimatedSection className="stest-section stest-section--white">
              <div className="stest-container stest-split">
                <div>
                  <SectionHeader
                    eyebrow="Regression Testing"
                    title="Best Regression Testing Company in Bangalore"
                    center={false}
                  />
                  <p>
                    WebTech is the best regression testing company in Bangalore to explore
                    regression testing used in the enterprise. In a world of software testing
                    there are many methodologies and regression testing is one of them.
                  </p>
                  <p>
                    Regression testing is performed to ensure that any changes made in the
                    system do not impact the previously working functionality. Changes may be
                    in any form like software enhancements, patches, configuration changes etc.
                    It verifies that recent program or code change has not affected existing
                    features. It ensures that old code still functions properly with
                    installation of new codes. It includes re-running of test cases to validate
                    proper functioning. Such testing makes the software more productive and
                    effective which boosts sales growth. This test is very vital when there is
                    continuous change in any application.
                  </p>
                </div>
                <div>
                  <h3 className="stest-subtitle">Why Regression Testing?</h3>
                  <div className="stest-check-list">
                    {regressionBenefits.map((item) => (
                      <div className="stest-check-item stest-check-item--inline" key={item}>
                        <CheckIcon />
                        <p>{item}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </AnimatedSection>

            {/* Mobile Testing */}
            <AnimatedSection className="stest-section">
              <div className="stest-container stest-split">
                <div>
                  <SectionHeader
                    eyebrow="Mobile Testing"
                    title="Mobile Application Testing"
                    center={false}
                  />
                  <p>
                    Nowadays there can be seen an increase in number of mobiles, smartphones,
                    tablets and many other mobile applications. Mobile has become a primary
                    resource of communication. It is no longer a device for communication only
                    but is a multipurpose gadget. Consumers use mobile to run various
                    applications on it. Many applications come in the market and it is consumers
                    who decide which mobile application should survive.
                  </p>
                  <p>
                    This is why it is important to ensure the functionality and performance of
                    the mobile application. There is a wide variety of mobile applications from
                    video up to banking applications on different operating systems like Android,
                    iOS etc. Mobile application testing is the process through which applications
                    designed for mobile devices are tested to check functionality, performance,
                    usability and consistency. It can be both automated and manual. It ensures a
                    positive experience for customers when they use mobile applications.
                  </p>
                </div>
                <div className="stest-mobile-card">
                  <h3>Importance of Mobile Testing</h3>
                  <p>
                    Mobile application testing is an essential factor in the process of
                    application development. Still there are many who are unaware of the utility
                    of mobile application testing. Here are the various advantages:
                  </p>
                  <ul className="stest-bullet-list">
                    {mobileBenefits.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </AnimatedSection>

            {/* CTA */}
            <AnimatedSection className="stest-cta">
              <div className="stest-container stest-cta__inner">
                <div>
                  <span>Quality First</span>
                  <h2>Ready to Ship Bug-Free Software?</h2>
                  <p>
                    Partner with WebTech for functional, performance, regression, and mobile
                    testing that protects your brand and your users.
                  </p>
                </div>
                <Link className="stest-btn stest-btn--white" to="/contact">
                  Start Testing Today
                </Link>
              </div>
            </AnimatedSection>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SoftwareTestingPage;
